import { connect } from 'react-redux'
import subCardSelector from './subCardSelector'
import requestRemoveCardParent from '../../sagas/requestRemoveCardParent'
import SubCard from './SubCard'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  subCardSelector,
  {
    requestRemoveCardParent
  },
  null,
  {
    forwardRef: true,
  }
)(SubCard))
